/**
 * Hard-coded L2 educational banners for the Rescued aisle.
 * Keyed by the L2 aisle name returned from the rescued-aisle API.
 * Images live at `boysenberry/images/<imageName>_desktop.jpg` / `_mobile.jpg`
 * (AisleBannerContent prepends STATIC_CONTENT_URL, so paths are relative to that host.)
 */
export const RESCUED_AISLE_BANNERS = {
    'Imperfect but Delicious': {
        copy: "Traditional grocery stores reject produce with surface quirks, funny shapes, or color variation. We know better: it's still nutritious, fresh, and delicious, plus you get it at a discount.",
        imageName: 'imperfect-but-delicious',
    },
    'Different Sizes': {
        copy: "Produce doesn't always grow uniformly, but supermarkets want everything to look the same. We buy a full range of sizes—big, small, and everything between—then pass savings on to you.",
        imageName: 'different-sizes',
    },
    'Different Packaging': {
        copy: "The label's a little off or the company changed branding, yet grocery stores won't accept mixed styles on the shelf. What's inside is exactly the same—and priced lower for the mismatch.",
        imageName: 'different-packaging',
    },
    'Extra & Surplus': {
        copy: "Sometimes a harvest goes better than expected, or a brand ends up with more than they can sell. It's not second-rate, just great food that deserves a good home.",
        imageName: 'extra-and-surplus',
    },
    'Mystery Items': {
        copy: 'A surprise variety of the freshest produce of the season. By saying yes to whatever type is ready to harvest, you help farmers earn more and prevent waste.',
        imageName: 'mystery-items',
        linkStyle: 'inline',
        linkTitle: 'Learn More',
        linkURL: 'https://blog.misfitsmarket.com/farm-fresh-produce-mystery-bundles/',
    },
    'Upcycled Ingredients': {
        copy: "High-quality parts of food saved from going to waste during manufacturing, combined with other top-notch ingredients to create something even better that's worth every penny.",
        imageName: 'upcycled-ingredients',
        linkStyle: 'inline',
        linkTitle: 'Learn More',
        linkURL: 'https://blog.misfitsmarket.com/upcycled-foods/',
    },
    'Last Call': {
        copy: "Getting close to its best-by date, recently discontinued, or leaving our shelves for good, but still fresh and tasty, never expired. We'd rather you enjoy it than see it go to waste.",
        imageName: 'last-call',
    },
};

export function getRescuedAisleBanners(aisles) {
    return aisles.flatMap((aisle) => {
        const bannerContent = RESCUED_AISLE_BANNERS[aisle.name];
        if (!bannerContent) return [];

        const { imageName, ...banner } = bannerContent;
        // Banner display prepends STATIC_CONTENT_URL
        const imageBasePath = `boysenberry/images/${imageName}`;

        return [
            {
                ...banner,
                largeImage: `${imageBasePath}_desktop.jpg`,
                smallImage: `${imageBasePath}_mobile.jpg`,
                taxonomyID: aisle.id,
            },
        ];
    });
}
